/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./logo.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./logo.component";
import * as i3 from "../Globals";
import * as i4 from "../services/login.service";
import * as i5 from "@ngx-progressbar/core";
import * as i6 from "../objects/Globals";
import * as i7 from "@angular/router";
import * as i8 from "../services/main-loading.service";
import * as i9 from "../services/workflow-return.service";
var styles_LogoComponent = [i0.styles];
var RenderType_LogoComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_LogoComponent, data: {} });
export { RenderType_LogoComponent as RenderType_LogoComponent };
export function View_LogoComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "logo-container"]], [[2, "default", null]], [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.goToHome() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 0, "img", [["src", "../../assets/images/portal_logo.png"]], null, null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.startPage; _ck(_v, 0, 0, currVal_0); }); }
export function View_LogoComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-logo", [], null, null, null, View_LogoComponent_0, RenderType_LogoComponent)), i1.ɵdid(1, 245760, null, 0, i2.LogoComponent, [i3.TokenManager, i4.LoginService, i5.NgProgress, i6.Globals, i7.Router, i8.MainLoadingService, i9.WorkflowReturnService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LogoComponentNgFactory = i1.ɵccf("app-logo", i2.LogoComponent, View_LogoComponent_Host_0, {}, {}, []);
export { LogoComponentNgFactory as LogoComponentNgFactory };
